module.exports = __webpack_public_path__ + "2fdb0215adaa32e31a07a061eab29cd9.png";